import { useEffect, useState } from "react";
import { Loader2, LogOut } from "lucide-react";
import { fotoApi, FOTO_TOKEN_KEY } from "./fotoApi";
import { FotoLogin } from "./FotoLogin";
import { FotoSearch } from "./FotoSearch";
import { FotoUpload } from "./FotoUpload";
import { useFotoPwaHead } from "./FotoPwa";

export default function FotoPage() {
  const [user, setUser] = useState(undefined);
  const [pratica, setPratica] = useState(null);
  useFotoPwaHead();

  useEffect(() => {
    if (!localStorage.getItem(FOTO_TOKEN_KEY)) { setUser(null); return; }
    fotoApi.get("/me").then(({ data }) => setUser(data)).catch(() => { localStorage.removeItem(FOTO_TOKEN_KEY); setUser(null); });
  }, []);

  const logout = async () => {
    await fotoApi.post("/logout").catch(() => {});
    localStorage.removeItem(FOTO_TOKEN_KEY); setUser(null); setPratica(null);
  };

  return (
    <div className="min-h-screen bg-slate-100" data-testid="foto-page">
      <div className="mx-auto max-w-md px-4 py-5">
        {user === undefined ? (
          <div className="py-20 flex justify-center"><Loader2 className="h-8 w-8 animate-spin text-amber-500" /></div>
        ) : !user ? (
          <FotoLogin onLogged={setUser} />
        ) : (
          <>
            <div className="flex items-center justify-between mb-4">
              <span className="text-sm text-slate-600 truncate" data-testid="foto-user-name">{user.name}</span>
              <button type="button" onClick={logout} data-testid="foto-logout" className="inline-flex items-center gap-1.5 text-sm font-medium text-slate-600 py-2 px-2">
                <LogOut className="h-4 w-4" /> Esci
              </button>
            </div>
            {pratica ? <FotoUpload pratica={pratica} onBack={() => setPratica(null)} /> : <FotoSearch onSelect={setPratica} aiTarga={!!user.ai_targa} />}
          </>
        )}
      </div>
    </div>
  );
}
